import { NavConfig } from '../data/constants/nav';
import { NavLinkConfig, NavLinkId } from '../data/types/nav';
import { TxNameCode } from '../data/types/tx';

const migratedLinks = (...linkIds: NavLinkId[]) =>
  linkIds.reduce(
    (acc, id) => ({ ...acc, [id]: NavConfig.linkConfigs[id] }),
    {} as Partial<Record<NavLinkId, NavLinkConfig>>
  );
// DEV/LOCAL use dev links
export const devMigratedLinks = migratedLinks(
  'MN_ADDENDUM_C',
  'TX_DAILY_TRANS_BULLETIN',
  'TX_INJURED_INACTIVE_REHAB',
  'TX_TAXI_SQUAD',
  'TX_PLAYER_TRACKING',
  'TX_PIEF_LIST',
  'TX_PIEF_LIST_FORM',
  'TX_ELECT_FREE_AGENCY_XX_B_',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_MJ_MN_ROSTERS',
  'SYS_BATCHES',
  'SYS_EMAILS',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'ADVANCED_SEARCH',
  'CLIPBOARD',
  'E_SIGNATURE',
  'RSTR_TWO_WAY_PLAYERS',
  'MJ_AWARD_BONUS_PACKAGES',
  'AWARD_BONUS_PACKAGE',
  'MN_VERIFICATION',
  'MN_DRAFT_CONTRACTS',
  'MN_ASSIGNMENT',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'INT_WLP_CLUB_COMMS',
  'PROFILE_PRO_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'EMP_ROSTERS',
  'EMP_DOCTORS',
  'EMP_TRANSLATORS',
  'EMP_PERMISSION_REQUESTS',
  'EMP_PERMISSION_REQUEST',
  'INT_DRUG_TEST_REQUESTS',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'R4_SCHOOLS',
  'R4_SCHOOL',
  'R4_DRAFT_LIVE',
  'R4_DRAFT_DAY_BOC',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_EMP_HISTORY',
  'PROFILE_EMP_CONTRACTS',
  'CEP_PLAYERS',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'RSTR_ELIGIBLE_FOR_DUGOUT',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_DRAFT_ORDER',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'RSTR_DETAILS',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA',
  'PROFILE_PRO_INFO',
  'PROFILE_INT_AMA_CONTRACTS_AND_INV',
  'PROFILE_INT_AMA_CONTRACTS',
  'PROFILE_INT_AMA_INFO',
  'INT_NEW_PLAYER',
  'TX_IL_RECERTIFICATION',
  'TRANSACTION',
  'PROFILE_INT_AMA_SUMMARY',
  'MJ_AWARD_ENTRY',
  'PROFILE_WV_AND_TX',
  'PROFILE_SERVICE',
  'PROFILE_PRO_INTERNATIONAL',
  'PROFILE_DRAFT_AND_SCOUTING'
);

// STG/TRN/BF/PROD use prod links
export const prodMigratedLinks = migratedLinks(
  'MN_DRAFT_CONTRACTS',
  'MN_ADDENDUM_C',
  'TX_INJURED_INACTIVE_REHAB',
  'RSTR_MJ_SUMMARY',
  'RSTR_MN_SUMMARY',
  'RSTR_MJ_MN_ROSTERS',
  'RSTR_TWO_WAY_PLAYERS',
  'TX_PLAYER_TRACKING',
  'TX_PIEF_LIST',
  'TX_PIEF_LIST_FORM',
  'SYS_BATCHES',
  'SYS_BATCH_UTILITY',
  'SYS_SYSTEM_DATES',
  'SYS_MNFA_PROCESS',
  'SYS_END_OF_SEASON_SERVICE_PROCESS',
  'ADVANCED_SEARCH',
  'MN_VERIFICATION',
  'MN_ASSIGNMENT',
  'EMP_ROSTERS',
  'EMP_PERMISSION_REQUESTS',
  'EMP_PERMISSION_REQUEST',
  'PROFILE_PRO_HISTORY',
  'PROFILE_EMP_HISTORY',
  'PROFILE_PRO_SUMMARY',
  'CSP_SCHOOL',
  'CEP_SCHOOLS',
  'CEP_PLAYERS',
  'CLIPBOARD',
  'INT_DRUG_TEST_REQUESTS',
  'UTIL_AFFILIATES',
  'AFFILIATE_PROFILE',
  'INT_WLP_CLUB_COMMS',
  'R4_DRAFT_LIVE',
  'R4_DRAFT_DAY_BOC',
  'R4_DRAFT_DAY_CLUB',
  'R4_DRAFT_DISPLAY',
  'R4_POST_DRAFT',
  'R4_CONNECTIVITY',
  'R4_COMM_SCREEN_DISPLAY',
  'R4_DRAFT_TEST_PICKER',
  'PROFILE_PRO_CONTRACTS',
  'PROFILE_PRO_CONTRACTS_AND_INV',
  'INT_L2_REG',
  'INT_L1_REG',
  'RSTR_PARTNER_LEAGUE',
  'TX_TAXI_SQUAD',
  'R5_DRAFT_LIVE',
  'R5_DRAFT_ADMIN',
  'R5_DRAFT_HISTORY',
  'R5_DRAFT_ORDER',
  'R5_RESERVE_LISTS',
  'R5_SELECTABLE_PLAYERS',
  'PROFILE_EMP_CONTRACTS',
  'TX_PLAYER_TRACKING',
  'TX_DAILY_TRANS_BULLETIN',
  'REPORTS',
  'UTIL_SOCIAL_MEDIA',
  'PROFILE_INT_AMA_CONTRACTS_AND_INV',
  'PROFILE_INT_AMA_CONTRACTS',
  'PROFILE_INT_AMA_INFO',
  'INT_NEW_PLAYER',
  'PROFILE_INT_AMA_SUMMARY',
  'MJ_AWARD_BONUS_PACKAGES',
  'AWARD_BONUS_PACKAGE',
  'E_SIGNATURE',
  'SYS_EMAILS',
  'RSTR_DETAILS',
  'TRANSACTION',
  'PROFILE_PRO_INFO',
  'TX_ELECT_FREE_AGENCY_XX_B_'
);

export const devMigratedTx: TxNameCode[] = ['MJSEL', 'RELES', 'TRANS', 'FADML'];

export const prodMigratedTx: TxNameCode[] = [
  'MJSEL',
  'RELES',
  'TRANS',
  'FADML',
];
